class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    // OONA CUSTOM (02/11) — comportement type Sklum : si la variante a une
    // image, le clic bascule l'image de la carte sans quitter la collection ;
    // les liens de la carte pointent alors vers cette variante. Sans image,
    // on garde l'ancien comportement (navigation vers la fiche).
    const image = swatch.dataset.variantImage;
    const card = this.closest('product-card');
    if (image && card) {
      const slide = card.querySelector('.splide__slide:not(.splide__slide--clone) img')
        || card.querySelector('.product-card-media-gallery__media img');
      if (slide) {
        slide.src = image;
        slide.removeAttribute('srcset');
      }
      card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        link.href = swatch.dataset.href;
      });
      this.querySelectorAll('[data-href]').forEach((s) => s.removeAttribute('aria-checked'));
      swatch.setAttribute('aria-checked', 'true');
      return;
    }

    window.location.href = swatch.dataset.href;
  };
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
